import { literal, number, preprocess } from 'zod';

import { CountProductsBySchema, ProductPurchaseSchema } from '@occc/validation';
import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { BaseSweepstakesSchema } from './base-sweepstakes.schema';

import { SweepstakesType } from '../types';

// `countProductsBy` is not offered by the Sweepstakes form (the "Count Products By"
// select is hidden), so it stays optional and falls back to Quantity on submit.
export const ProductPurchaseEarningMechanismSchema = ProductPurchaseSchema.extend({
  purchaseThreshold: number({ required_error: IS_REQUIRED }).positive(IS_POSITIVE),
  countProductsBy: CountProductsBySchema.optional(),
});

export const ProductPurchaseFormSchema = BaseSweepstakesSchema.extend({
  sweepstakesType: literal(SweepstakesType.ProductPurchase),
  productPurchase: preprocess((value) => value ?? {}, ProductPurchaseEarningMechanismSchema),
});
